module.exports = __webpack_public_path__ + "2dd4b0476e1f0b03f1fc93f236c7c051.svg";